import {EsquireClient} from "@/types/clients/esquire";
import Passport from "@/types/clients/esquire/data/general/passport";

export default class PostImageRequest {
  constructor(private client: EsquireClient) {
  }

  public async send(contractId: string, files?: File | File[]): Promise<Passport | null> {
    const url = await this.client.fetchUrlFromSession("upload-image");

    const formData = new FormData();
    formData.append("contract_id", contractId);
    if (files instanceof File) {
      formData.append("files[]", files, files.name);
    }

    const response = await this.client.fetch(
      () => new URL(url), {
        method: "POST",
        body: formData
      });

    if (!response.ok) {
      await this.client.logOutIfForbidden(response.status);
      return null;
    }

    const contentType = response.headers.get("Content-Type");
    if (contentType && contentType.includes("application/json")) {
      try {
        const text = await response.text();
        if (text) {
          const result = JSON.parse(text);
          return new Passport(result);
        }
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }

    return null;
  }
}
